import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const resendLabel = {
  name: "resendLabel" as const,
  input: z.object({
    returnId: zExt.objectId(),
    emailOverride: z.string().optional(),
  }),
  output: z.object({ success: z.boolean(), message: z.string().optional() }),
};
